import {
  APPLE_PROMO_CODE_FEATURE_FLAG,
  IS_WEB_VIEW,
} from "common/constants.ts";
import { AuthUser } from "@shared/types";

interface usePromoCodeProps {
  user?: AuthUser;
}

export const useDisplayPromoCode = ({ user }: usePromoCodeProps) => {
  return !IS_WEB_VIEW || user?.hasFeatureFlag(APPLE_PROMO_CODE_FEATURE_FLAG);
};
